import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';
import type { ApiRequestOptions } from '@/services/bff/types/common';

type ScopedRequestOptions = ApiRequestOptions;
type TypedRequest = <T = unknown>(
  url: string,
  options?: ScopedRequestOptions,
) => Promise<T>;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return ((url: string, options?: ScopedRequestOptions) => {
    const nextOptions: Record<string, unknown> = {
      ...(options || {}),
      baseURL: scopedBaseURL,
    };

    if ('getResponse' in nextOptions && nextOptions.getResponse === undefined) {
      delete nextOptions.getResponse;
    }
    if ('responseType' in nextOptions && nextOptions.responseType === undefined) {
      delete nextOptions.responseType;
    }

    return umiRequest(url, nextOptions as never);
  }) as TypedRequest;
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);

export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
